/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Logistics_Driver_CheckinInputs */

const en_orders_logistics_driver_checkin = /** @type {(inputs: Orders_Logistics_Driver_CheckinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driver Check-In`)
};

const es_orders_logistics_driver_checkin = /** @type {(inputs: Orders_Logistics_Driver_CheckinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrada del chofer`)
};

/**
* | output |
* | --- |
* | "Driver Check-In" |
*
* @param {Orders_Logistics_Driver_CheckinInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_logistics_driver_checkin = /** @type {((inputs?: Orders_Logistics_Driver_CheckinInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Logistics_Driver_CheckinInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_logistics_driver_checkin(inputs)
	return es_orders_logistics_driver_checkin(inputs)
});